
export const isLocal = window.location.hostname.includes('localhost');
export const TOKEN_KEY = "jwt_token";
export const USER_KEY = "auth_user";
export const EXPIRY_KEY = "jwt_expiry"; // epoch ms when token expires
export const SWIPE_THRESHOLD = 60;
export const GOOGLE_CLIENT_ID = "429588081210-j7fd63molcgoevdp73jki0ms20b3utg4.apps.googleusercontent.com";
 
// Fallback BCP-47 region tags for common 2-letter language codes, used when
// no installed voice matches so the browser can still pick a sensible default.
export const DEFAULT_LOCALE_TAGS: Record<string, string> = {
  en: "en-US",
  pl: "pl-PL",
  es: "es-ES",
  fr: "fr-FR",
  de: "de-DE",
  it: "it-IT",
  pt: "pt-PT",
};

export const copyIcon = "📋";
export const openFolderIcon = "📂";
export const moveToIcon = "➡️";
export const flashCard = "🤓";  
export const mucisIcon = "🎵";
export const musicIcons = "🎶";
export const settingsIcon = "⚙️";
export const changePasswordIcon = "🔒";
export const logoutIcon = "🔚";
export const notebookIcon = "📝";
export const exampleIcon = "♻️";
export const openaiIcon = "✨";
export const messageIcon = "📬";

export const saveIcon = "💾";
export const analiseIcon = "👁️";
export const editIcon = "✏️";
export const approveIcon = "✅";
export const rejectIcon = "🚫";
export const infoIcon = "ℹ️";
export const warningIcon = "⚡";
export const errorIcon = "🛑";
export const userIcon = "🧑";
export const cancelIcon = "❌";
export const sendIcon = "📤";
export const okIcon = "✔️";
export const addIcon = "➕";
export const printIcon = "🖨️";
export const deleteIcon = "🗑️";
export const newIcon = "📄";
export const changeIcon = "🖌️";
export const closeIcon = "🔒";
export const speakIcon = "📢";

//🛠️🔧🧩✨♻️🪄☄️⚡🔮💎🌠✧✦🔯💫🌟⭐
//❌ 🚫 ⛔ ⚠️ ❗ ❕ 🙅‍♂️ 🙅‍♀️ 🛑👩‍⚖️
//🔍 🔎 🧐 👁️ 👁️‍🗨️ 🧠 🔊
//💬 🗨️ 📨 ✉️ 📞 🔔 🛎️ 📣 📢
//📊 📈 📉 📋 📌 📍 🧮 📅 📆
//📎 📌 🔗 🧭 🗺️ 🎛️ 🎚️ 🪙 🧿 🧲
//📥 📤 ⬇️ ⬆️ 💾 📨 📦 📬 📭 ➡️
//🗑️ ❌ ⛔ 🚫 🔥 🧹 ✂️ 🔒
//✅ ☑️ ✔️ 🆗 👍 🙌 🏁 🎯
//🔄 🔃 🔁 🔀 🔂 🔽 🔼 ↕️ ⬆️ ⬇️ ↩️ ↪️
//💾 📂 📁 🗂️ 📄 📃 📜 📰 🗃️ 📇
//🎨 🖌️ 🧵 ✂️ 🧷 🖼️ 📐 📏 🧲 🖍️
//🧑‍💻 👨‍💻 👩‍💻 🖥️ 💻 📟 🧮 🗂️ 🧾
//⚙️ 🔧 🪛 🧰 🧱 🧲 🧪 🛠️ 🧿 🪙
//✏️ 📝 🖊️ 🖋️ 🪶 🖌️ 🧾 📄 📋 📌 📎
//🧑👨👮👶🧓🧔👥👤 🖨️
//["🎵", "🎶", "🎼", "🎤", "🎧", "🎷", "🎸", "🥁", "🎹"];